import styled from 'styled-components';

export const ContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 25px;
`;

export const HeaderWrapperStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleStyled = styled.h1`
  margin: 0;
`;

export const TextStyled = styled.h3`
  margin: 2em 0 0;
`;

export const ErrorStackStyled = styled.div`
  color: var(--ds-text-danger, var(--ds-fb-text-danger));
  padding: 1em 0 3em 2em;
`;

export const ContactStyled = styled.p`
  margin: 0;
`;

export const ButtonWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid var(--ds-border, var(--ds-fb-border));
`;
